import { useContext } from 'react';
import Constants from '@usas/ui-web/utils/Constants';

import { OrgUnitAthleteEntryInfoStateContext } from './OrgUnitAthleteEntryInfoContextProvider';

import OrgUnitAthleteEntryInfoData from './OrgUnitAthleteEntryInfoData';

const useOrgUnitAthleteEntryInfoData = () => {
  const [orgUnitAthleteEntryInfoState, setOrgUnitAthleteEntryInfoState] = useContext(OrgUnitAthleteEntryInfoStateContext);

  const getOrgUnitAthleteEntryInfo = (orgUnitAthleteEntryId) => {
    OrgUnitAthleteEntryInfoData.getOrgUnitAthleteEntryInfoData(orgUnitAthleteEntryId, orgUnitAthleteEntryInfoState, setOrgUnitAthleteEntryInfoState);
  };

  const clearOrgUnitAthleteEntryInfoObjData = () => {
    setOrgUnitAthleteEntryInfoState({
      ...orgUnitAthleteEntryInfoState,
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {},
      orgUnitAthleteEntryId: Constants.DEFAULT_ID,
      message: ''
    });
  };

  return {
    orgUnitAthleteEntryInfoState,
    setOrgUnitAthleteEntryInfoState,
    getOrgUnitAthleteEntryInfo,
    clearOrgUnitAthleteEntryInfoObjData
  };
};

export default useOrgUnitAthleteEntryInfoData;